<template>
  <div class="div_header">
    <div class="layout">
      <div style="float:left;">
          <Logo />
          <span class="center-name">外事管理服务系统</span>
      </div>
      <div class="header_login_info" v-if="oidcUser">
        <a-dropdown>
        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
          <a href="#" class="clickForUl">
            <a-icon type="user" class="icon-linear" />
            {{Name}}
          </a>
        </a>
        <a-menu slot="overlay" size="small">
            <a-menu-item v-if="deskShow">
              <a :href="deskUri" target="_blank">进入后台</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="signOutOidc">注销登录</a>
            </a-menu-item>
        </a-menu>
      </a-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Seq from "../modules/Search";
import HeaderTabItem from "../modules/HeaderTabItem";
import BnIcon from '../common/bannerIcons.vue'
import gql from "@/graphql/apollo";
import apolloProvider from "@/apolloConfig";

const appcenterApollo = apolloProvider.clients.power

export default {
  name: "",
  data() {
    return {
      userName: "",
      account: "",
      deskShow:false,
    };
  },
  components: {
    Seq,
    HeaderTabItem,
    BnIcon
  },
  watch:{
    Name:{
      handler(val,oldVal){
        if(val!=oldVal){
          this.$store.dispatch('metodoLength',true);
          this.getManagePower();
        }
      }
    }
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    dataLength() {
      return this.$store.getters.getDataLength;
    },
    deskUri(){
      return location.origin+"/fa-sys/manage/home";
    },
    Name(){
      let user = this.$store.getters.getUserInfo;
      if(user && user.name){
        return user.name;
      }else{
        return ''
      }
    },
  },

  methods: {
    ...mapActions("oidcStore", ["signOutOidc"]),
    getManagePower(){
      let account = this.$store.getters.getId
      let filter = {};
      filter['account'] = {
          eq: account
      }
      appcenterApollo.query({
            client: 'power',
            fetchPolicy: "network-only",
            query: gql.positions,
            variables: {
                filter
            },
        }).then(res => {
            let dataP = JSON.stringify(res.data.canvasmenus);
            this.deskShow =  dataP.indexOf('外事系统后台')!=-1;
        }).catch(error => {
            console.error(error)
        });
    }
  },
};
</script>
<style>
.clickForUl{
  line-height: 11.5vh;
  padding-right: 10px;
}
.clickForUl .icon-linear {
 font-size: 15px;
 padding: 7px;
 background: linear-gradient(#0085e9,#eee);
 color: #fff;
 border-radius: 50%;
}

.center-name{
  color:#0062AC;
  font-size:22px;
  padding-left:15px;
  margin-left: 15px;
  font-weight: bold;
  border-left: 3px solid rgba(0, 98, 172, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/Header.vue